import React from 'react';

import StockSpecialFilterCheckbox from '@/components/StockSpecialFilterCheckbox';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarPartnerCar,
  setPage,
} from '@/store/reducers/cars-stock';
import { OptionType } from '@/typings/common';
import { getSpecialFilterOptionById } from '@/modules/CarsStock/components/common.helpers';
import { CarsStockFlag } from '@/services/stock/enums';

export function PartnerCarFilter() {
  const dispatch = useTypedDispatch();
  const selectedPartnerCar =
    useTypedSelector(getSelectedFilters).selectedParams.selectedSpecials
      .selectedPartnerCar;
  const stockFilterParams = useTypedSelector(getStockFilterParams);

  const partnerCarOption = getSpecialFilterOptionById(
    stockFilterParams,
    CarsStockFlag.PartnerCar
  );

  const handleChangePartnerCar = (partnerCar: OptionType) => {
    if (!selectedPartnerCar.value) {
      dispatch(setCarPartnerCar(partnerCar));
    } else {
      dispatch(setCarPartnerCar({ label: '', value: '' }));
    }
    dispatch(setPage(1));
  };

  return (
    <StockSpecialFilterCheckbox
      checked={!!selectedPartnerCar.value}
      option={partnerCarOption}
      onChange={handleChangePartnerCar}
    />
  );
}
